import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlus, FiTrash2, FiEdit3, FiSave, FiX, FiExternalLink } = FiIcons;

const ChecklistBuilder = ({ 
  checklists, 
  activeChecklist, 
  setActiveChecklist, 
  updateChecklist, 
  deleteChecklist,
  darkMode 
}) => {
  const [editingItem, setEditingItem] = useState(null);
  const [editingTitle, setEditingTitle] = useState(false);

  const addItem = () => {
    if (!activeChecklist) return;
    
    const newItem = {
      id: Date.now(),
      title: 'Novo Marco',
      description: 'Descrição do marco',
      link: '',
      completed: false
    };
    
    updateChecklist({
      ...activeChecklist,
      items: [...activeChecklist.items, newItem]
    });
  };

  const updateItem = (itemId, updates) => {
    if (!activeChecklist) return;
    
    updateChecklist({
      ...activeChecklist,
      items: activeChecklist.items.map(item =>
        item.id === itemId ? { ...item, ...updates } : item
      )
    });
  };

  const deleteItem = (itemId) => {
    if (!activeChecklist) return;
    
    updateChecklist({
      ...activeChecklist,
      items: activeChecklist.items.filter(item => item.id !== itemId)
    });
  };

  const moveItem = (index, direction) => {
    if (!activeChecklist) return;
    
    const newItems = [...activeChecklist.items];
    const newIndex = direction === 'up' ? index - 1 : index + 1;
    
    if (newIndex >= 0 && newIndex < newItems.length) {
      [newItems[index], newItems[newIndex]] = [newItems[newIndex], newItems[index]];
      updateChecklist({ ...activeChecklist, items: newItems });
    }
  };

  if (!activeChecklist) {
    return (
      <div className={`rounded-xl p-8 text-center ${
        darkMode ? 'bg-gray-800' : 'bg-white'
      }`}>
        <SafeIcon icon={FiPlus} className="text-4xl text-gray-400 mx-auto mb-4" />
        <p className={`text-lg ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
          Crie sua primeira lista de marcos
        </p>
      </div>
    );
  }

  return (
    <div className={`rounded-xl p-6 ${darkMode ? 'bg-gray-800' : 'bg-white'} shadow-lg`}>
      <div className="mb-6">
        <div className="flex items-center justify-between mb-4">
          {editingTitle ? (
            <div className="flex-1 flex items-center space-x-2">
              <input
                type="text"
                value={activeChecklist.title}
                onChange={(e) => updateChecklist({
                  ...activeChecklist,
                  title: e.target.value
                })}
                className={`flex-1 text-xl font-bold bg-transparent border-b-2 border-blue-600 focus:outline-none ${
                  darkMode ? 'text-white' : 'text-gray-900'
                }`}
                autoFocus
              />
              <button
                onClick={() => setEditingTitle(false)}
                className="text-green-600 hover:text-green-700"
              >
                <SafeIcon icon={FiSave} />
              </button>
            </div>
          ) : (
            <div className="flex items-center space-x-2">
              <h2 className="text-xl font-bold">{activeChecklist.title}</h2>
              <button
                onClick={() => setEditingTitle(true)}
                className={`text-gray-400 hover:text-gray-600 ${
                  darkMode ? 'hover:text-gray-300' : ''
                }`}
              >
                <SafeIcon icon={FiEdit3} />
              </button>
            </div>
          )}
          
          <select
            value={activeChecklist.id}
            onChange={(e) => {
              const selected = checklists.find(cl => cl.id === parseInt(e.target.value));
              setActiveChecklist(selected);
            }}
            className={`px-3 py-2 rounded-lg border ${
              darkMode 
                ? 'bg-gray-700 border-gray-600 text-white' 
                : 'bg-white border-gray-300'
            }`}
          >
            {checklists.map(cl => (
              <option key={cl.id} value={cl.id}>{cl.title}</option>
            ))}
          </select>
        </div>

        <textarea
          value={activeChecklist.description}
          onChange={(e) => updateChecklist({
            ...activeChecklist,
            description: e.target.value
          })}
          placeholder="Descrição da lista..."
          className={`w-full p-3 rounded-lg border resize-none ${
            darkMode 
              ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
              : 'bg-gray-50 border-gray-300 placeholder-gray-500'
          }`}
          rows="2"
        />
      </div>

      <div className="space-y-4">
        {activeChecklist.items.map((item, index) => (
          <div key={item.id} className={`border rounded-lg p-4 ${
            darkMode ? 'border-gray-600 bg-gray-700' : 'border-gray-200 bg-gray-50'
          }`}>
            {editingItem === item.id ? (
              <div className="space-y-3">
                <input
                  type="text"
                  value={item.title}
                  onChange={(e) => updateItem(item.id, { title: e.target.value })}
                  className={`w-full p-2 rounded border ${
                    darkMode 
                      ? 'bg-gray-600 border-gray-500 text-white' 
                      : 'bg-white border-gray-300'
                  }`}
                  placeholder="Título do marco"
                />
                <textarea
                  value={item.description}
                  onChange={(e) => updateItem(item.id, { description: e.target.value })}
                  className={`w-full p-2 rounded border resize-none ${
                    darkMode 
                      ? 'bg-gray-600 border-gray-500 text-white' 
                      : 'bg-white border-gray-300'
                  }`}
                  rows="2"
                  placeholder="Descrição do marco"
                />
                <input
                  type="url"
                  value={item.link}
                  onChange={(e) => updateItem(item.id, { link: e.target.value })}
                  className={`w-full p-2 rounded border ${
                    darkMode 
                      ? 'bg-gray-600 border-gray-500 text-white' 
                      : 'bg-white border-gray-300'
                  }`}
                  placeholder="https://exemplo.com"
                />
                <div className="flex justify-end space-x-2">
                  <button
                    onClick={() => setEditingItem(null)}
                    className="text-green-600 hover:text-green-700"
                  >
                    <SafeIcon icon={FiSave} />
                  </button>
                  <button
                    onClick={() => setEditingItem(null)}
                    className="text-gray-400 hover:text-gray-600"
                  >
                    <SafeIcon icon={FiX} />
                  </button>
                </div>
              </div>
            ) : (
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-2">
                    <h3 className="font-semibold">{item.title}</h3>
                    {item.link && (
                      <SafeIcon icon={FiExternalLink} className="text-blue-600 text-sm" />
                    )}
                  </div>
                  <p className={`text-sm mb-2 ${
                    darkMode ? 'text-gray-300' : 'text-gray-600'
                  }`}>
                    {item.description}
                  </p>
                  {item.link && (
                    <a
                      href={item.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:text-blue-700 text-sm break-all"
                    >
                      {item.link}
                    </a>
                  )}
                </div>
                <div className="flex items-center space-x-2 ml-4">
                  <button
                    onClick={() => moveItem(index, 'up')}
                    disabled={index === 0}
                    className="text-gray-400 hover:text-gray-600 disabled:opacity-30"
                  >
                    ↑
                  </button>
                  <button
                    onClick={() => moveItem(index, 'down')}
                    disabled={index === activeChecklist.items.length - 1}
                    className="text-gray-400 hover:text-gray-600 disabled:opacity-30"
                  >
                    ↓
                  </button>
                  <button
                    onClick={() => setEditingItem(item.id)}
                    className="text-blue-600 hover:text-blue-700"
                  >
                    <SafeIcon icon={FiEdit3} />
                  </button>
                  <button
                    onClick={() => deleteItem(item.id)}
                    className="text-red-600 hover:text-red-700"
                  >
                    <SafeIcon icon={FiTrash2} />
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mt-6 flex justify-between">
        <button
          onClick={addItem}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors flex items-center space-x-2"
        >
          <SafeIcon icon={FiPlus} />
          <span>Adicionar Marco</span>
        </button>

        <button
          onClick={() => deleteChecklist(activeChecklist.id)}
          className="text-red-600 hover:text-red-700 px-4 py-2 rounded-lg transition-colors"
        >
          Excluir Lista
        </button>
      </div>
    </div>
  );
};

export default ChecklistBuilder;